module.exports = __webpack_public_path__ + "img/operatingSystem_sign.51b97f27.png";